// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton {
  padding: 48px 24px 24px 24px;
}
.skeleton .input {
  height: 74px;
}
.skeleton .button {
  width: 80px;
  height: 40px;
}
.skeleton .button-wrapper {
  width: 80px;
  height: 40px;
  margin: 0 auto 16px;
}
.skeleton .qr {
  width: 116px;
  height: 116px;
}
.skeleton .qr-wrapper {
  width: 132px;
  height: 132px;
  padding: 8px;
  margin: 0 auto 8px auto;
}
.skeleton .download {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.skeleton .download-hint {
  line-height: 22px;
  font-size: 14px;
}
.skeleton .download-item {
  height: 32px;
  width: 112px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Authorization/less/skeleton.less"],"names":[],"mappings":"AAGA;EACI,4BAAA;AAFJ;AACA;EAIQ,YAAA;AAFR;AAFA;EAQQ,WAAA;EACA,YAAA;AAHR;AAKQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAHZ;AAXA;EAmBQ,YAAA;EACA,aAAA;AALR;AAOQ;EACI,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;AALZ;AArBA;EA+BQ,aAAA;EACA,6BAAA;EACA,mBAAA;AAPR;AASQ;EACI,iBAAA;EACA,eAAA;AAPZ;AAUQ;EACI,YAAA;EACA,YAAA;AARZ","sourcesContent":["@import (reference) \"../../../less/variables\";\n@import (reference) \"../../../less/mixins\";\n\n.skeleton {\n    padding: @gutter*6 @gutter*3 @gutter*3 @gutter*3;\n\n    .input {\n        height: 74px;\n    }\n\n    .button {\n        width: @gutter* 10;\n        height: @gutter*5;\n\n        &-wrapper {\n            width: @gutter* 10;\n            height: @gutter*5;\n            margin: 0 auto @gutter*2;\n        }\n    }\n\n    .qr {\n        width: 116px;\n        height: 116px;\n\n        &-wrapper {\n            width: 132px;\n            height: 132px;\n            padding: @gutter;\n            margin: 0 auto @gutter auto;\n        }\n    }\n\n    .download {\n        display: flex;\n        justify-content: space-around;\n        align-items: center;\n\n        &-hint {\n            line-height: @tlSmall;\n            font-size: @tsSmall;\n        }\n\n        &-item {\n            height: @gutter*4;\n            width: @gutter*14;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
